import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class UtilitiesService {
  getDepartments() {
    return axios
      .get(`${config.apiUrl}departments`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Erro ao buscar departamentos:", err);
        return [];
      });
  }
}

export default new UtilitiesService();
